import React, { Component, } from "react";
import Grid from '@mui/material/Grid';
import Button from "@mui/material/Button";
import EditDetailsPopup from "./EditDetailsPopup";
import get_and_post_data_skeleton from '../../common/common/get_and_post_data_skeleton';
import SettingsIconImageDiv from "../SettingsIconImageDiv";
import Switch from '@mui/material/Switch';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PasswordUpdatePopup from "./PasswordUpdatePopup";
import DeleteAccountPopup from "./DeleteAccount";
import EditIcon from '@mui/icons-material/Edit';
import MenuItem from '@mui/material/MenuItem';
import RestoreIcon from '@mui/icons-material/Restore';
import axios from "axios";
import SnackbarAlert from "../../common/SnackbarAlert";
import Select from '@mui/material/Select';
import { FaChevronDown } from 'react-icons/fa';
import PageSkeletonProfile from "../../common/skeletons/PageSkeletonProfile";
import { styled } from "@mui/material";
import { MdOutlineMailLock, MdOutlineMarkEmailRead, MdOutlineMarkEmailUnread } from "react-icons/md";
import { Box } from '@mui/material';

const paths = require('../../../paths.json');

const smallHeading = {
    color: '#000',
    fontSize: '15px',
    fontWeight: '600',
    margin: '0px auto 5px 0px',
    display: 'block',
 }
 
 const smallDescription = {
    color: '#6E89AF',
    fontSize: '14px',
    fontWeight: '500',
    margin: '0px auto 0px 0px',
    display: 'block',
 }

const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 36,
    height: 20,
    marginLeft: 5,
    padding: 0,
    display: 'flex',
    '&:active': {
        '& .MuiSwitch-thumb': {
            width: 20,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(7px)',
        },
    },
    '& .MuiSwitch-switchBase': {
        padding: 2,
        '&.Mui-checked': {
            transform: 'translateX(15px)',
            color: '#fff !important',
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: 'var(--brand-color)',
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
        width: 16,
        height: 16,
        borderRadius: 40,
        transition: theme.transitions.create(['width'], {
            duration: 200,
        }),
    },
    '& .MuiSwitch-track': {
        borderRadius: 100,
        opacity: 1,
        backgroundColor:
            theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
        boxSizing: 'border-box',
    },
}));


class CreatorProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'Profile',
            modalVisible: false,
            // user profile
            user_profile_info: [],
            user_profile_info_edited: [],
            country_list: [],
            selectedCountry: "",
            personal_edit_on: false,
            password_edit_visible: false,
            delete_account_visible: false,
            email_verified: false,
            email_opt_in: false,
            email_sent: false,
            errorMsg1: '',
            errorMsg2: '',
            discordConnected: false,
            settingsErrorMsg: '',
            successMsg: '',
            snackbar: false,
            snackColor: 'var(--brand-color)',
            loading: true,
            isLoading: true,
            activeTab: 'Profile',
            stripe_customer_id2: this.props.stripe_customer_id2,

        };
        this.get_profile_settings_page_django_data = this.get_profile_settings_page_django_data.bind(this);
        this.UpdatePersonalInfoPostUpdate = this.UpdatePersonalInfoPostUpdate.bind(this);
        this.UpdatePersonalInfo = this.UpdatePersonalInfo.bind(this);
        this.SubmitPersonalInfo = this.SubmitPersonalInfo.bind(this);
        this.EditPersonalInfoOn = this.EditPersonalInfoOn.bind(this);
        this.UpdateEmailOptInUpdate = this.UpdateEmailOptInUpdate.bind(this);
        this.VerifyEmailResendUpdate = this.VerifyEmailResendUpdate.bind(this);
    }

    getTabs() {
        return [
            { label: 'Profile' },
            ...(this.state.stripe_customer_id2 && this.state.stripe_customer_id2 !== '' ? [{ label: 'Billing'}] : [])
        ];
    }

    componentDidMount() {
        this.setState({ isLoading: true });
        Promise.resolve(this.get_profile_settings_page_django_data(
            paths.BACKEND_URL + "api/settings_page_profile_info",
            'get',
        )).then(() => {
            this.setState({ loading: false });
        });

        this.getDiscordStatus()

        axios({
            method: 'get',
            url: paths.BACKEND_URL + "api/settings_page_creator_billing_info",
            headers: {
               'Content-type': 'application/json',
            },
            withCredentials: true
         }).then(res => {
            this.setState({ link_url: res.data.link_url, isLoading: false });
         })
    }

    EditPersonalInfoOn() {
        this.setState({ personal_edit_on: true });
    }
    handleEmailOptInChange(event) {
        event.preventDefault();
        const form_data = new FormData();
        let email_opt_in_val = true
        if (this.state.email_opt_in) {
            email_opt_in_val = false
        }
        form_data.append('email_opt_in_update', email_opt_in_val);
        this.get_profile_settings_page_django_data(
            paths.BACKEND_URL + 'api/settings_post_processing/',
            'post',
            false,
            form_data,
            this.UpdateEmailOptInUpdate,
        )
    }
    UpdateEmailOptInUpdate(res) {
        this.setState({ email_opt_in: res.data.email_opt_in })
    }
    SendNewVerificationEmail(event) {
        event.preventDefault();
        const form_data = new FormData();
        form_data.append('email', this.state.user_profile_info['email']);
        this.get_profile_settings_page_django_data(
            paths.BACKEND_URL + 'api/new_verify_email',
            'post',
            false,
            form_data,
            this.VerifyEmailResendUpdate,
        )

    }
    VerifyEmailResendUpdate(res) {
        if (res.data.message) {
            if (res.data.message === 'New verification sent') {
                this.setState({ email_sent: true })

                this.setState({
                    snackbar: true,
                    successMsg: 'New email verification sent. Check your inbox',
                    snackColor: 'var(--brand-color)',
                })

            } else if (res.data.message === 'Already verified') {
                this.setState({ email_verified: true })

                this.setState({
                    snackbar: true,
                    successMsg: 'Email Already verified',
                    snackColor: 'var(--brand-color)',
                })
            }
        }
    }


    disconnectDiscord = async () => {
        const res = await axios(
            {
                method: 'get',
                url: paths.BACKEND_URL + 'api/oauth_disconnect',
                withCredentials: true
            })
        if (res.status === 200) {
            this.setState({ discordConnected: false })
        }
    }
    getDiscordStatus = async () => {
        const res = await axios({
            method: 'get',
            url: paths.BACKEND_URL + 'api/settings_page_profile_info',
            withCredentials: true
        })
        if (res.data) {
            this.setState({
                discordConnected: res.data.discord_linked
            })
        } else {
            // Error pulling data
        }
    }

    usernameValidation() {
        let special_char_regex = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        if (this.state.user_profile_info_edited['username'].length > 60 || this.state.user_profile_info_edited['username'].length < 4) {
            this.setState({
                errorMsg1: "Username must be between 4 and 60 characters",
            })
            return false;
        } else if (this.state.user_profile_info_edited['username'].indexOf(' ') >= 0) {
            this.setState({
                errorMsg1: "No spaces allowed in username",
            })
            return false
        } else if (special_char_regex.test(this.state.user_profile_info_edited['username'])) {
            this.setState({
                errorMsg1: "No special characters allowed in username",
            })
            return false
        }
        return true;
    }

    UpdatePersonalInfoPostUpdate(res) {
        if (res.data.error) {
            if (res.data.error === 'name already exists') {
                this.setState({
                    errorMsg2: 'Name taken, please choose a different one.'
                })
            } else if (res.data.error === 'username already exists') {
                this.setState({
                    errorMsg1: 'Username taken, please choose a different one.'
                })
            } else if (res.data.error === 'username can not contain special characters') {
                this.setState({
                    errorMsg1: "Username can not contain special characters"
                })
            } else if (res.data.error === 'username can not contain spaces') {
                this.setState({
                    errorMsg1: "Username can not contain spaces"
                })
            } else {
                this.setState({
                    errorMsg1: 'Error, please try again.'
                })
            }
        } else {
            // set is_profile_updated value in order to know whether need to redirect to profile or not in next reload
            localStorage.setItem("is_profile_updated", true)

            var personal_info = this.state.user_profile_info
            personal_info['name'] = res.data['name']
            personal_info['country'] = res.data['country']
            personal_info['gender'] = res.data['gender']
            personal_info['username'] = res.data['username']
            this.setState({ user_profile_info: personal_info });
            var personal_info_edited = this.state.user_profile_info_edited
            personal_info_edited['name'] = res.data['name']
            personal_info_edited['username'] = res.data['username']
            personal_info_edited['country'] = res.data['country']
            personal_info_edited['gender'] = res.data['gender']
            this.setState({ user_profile_info_edited: personal_info_edited });
            this.props.onDisplayNameUpdate(personal_info['name'])
            this.props.onUsernameUpdate(res.data['username'])
            this.setState({ personal_edit_on: false });
            this.setState({
                snackbar: true,
                successMsg: 'Profile Updated',
                snackColor: 'var(--brand-color)',
            })
        }
    }

    handleTabChange = (tabLabel) => {
        this.setState({ activeTab: tabLabel });
    };


    SubmitPersonalInfo(event) {
        event.preventDefault();
        if ((this.state.user_profile_info_edited['name'].length < 4) || this.state.user_profile_info_edited['name'].length > 60) {
            this.setState({
                errorMsg2: "Display name must be between 4 and 60 characters",
            })
        } else if ((this.state.user_profile_info_edited['username'].length < 4) || this.state.user_profile_info_edited['username'].length > 60) {
            this.setState({
                errorMsg1: "Username must be between 4 and 60 characters",
            })
        } else {
            if (this.usernameValidation()) {

                const form_data = new FormData();
                form_data.append('name', this.state.user_profile_info_edited['name']);
                form_data.append('country', this.state.user_profile_info_edited['country']);
                form_data.append('gender', this.state.user_profile_info_edited['gender']);
                form_data.append('username', this.state.user_profile_info_edited['username']);
                this.get_profile_settings_page_django_data(
                    paths.BACKEND_URL + 'api/settings_post_processing/',
                    'post',
                    false,
                    form_data,
                    this.UpdatePersonalInfoPostUpdate,
                )
            }
        }
    }

    UpdatePersonalInfo(event, key) {
        if (key === 'name') {
            if (event.target.value.length > 60) {

                if (event.target.value.length > 60) {
                    // don't update text
                    this.setState({
                        errorMsg2: "",
                        snackbar: true,
                        successMsg: 'Display name must be between 4 and 60 characters',
                        snackColor: 'var(--danger-color)',
                    })
                } else {
                    // Update Navbars from here
                    let user_profile_info_edited_copy = this.state.user_profile_info_edited
                    if (event.target.value === 'none selected') {
                        user_profile_info_edited_copy[key] = ''
                    } else {
                        user_profile_info_edited_copy[key] = event.target.value
                    }
                    this.setState({ user_profile_info_edited: user_profile_info_edited_copy })

                }
            } else if (event.target.value.length < 4) {
                this.setState({
                    errorMsg2: "Display name must be between 4 and 60 characters",
                })

                if (event.target.value.length > 60) {

                } else {
                    let user_profile_info_edited_copy = this.state.user_profile_info_edited
                    if (event.target.value === 'none selected') {
                        user_profile_info_edited_copy[key] = ''
                    } else {
                        user_profile_info_edited_copy[key] = event.target.value
                    }
                    this.setState({ user_profile_info_edited: user_profile_info_edited_copy })
                }
            }
            else {
                if (this.state.errorMsg2.length > 0) {
                    this.setState({
                        errorMsg2: "",
                    })
                }

                let user_profile_info_edited_copy = this.state.user_profile_info_edited
                if (event.target.value === 'none selected') {
                    user_profile_info_edited_copy[key] = ''
                } else {
                    user_profile_info_edited_copy[key] = event.target.value
                }
                this.setState({ user_profile_info_edited: user_profile_info_edited_copy })
            }

        } else if (key === 'username') {
            if (event.target.value.length > 60) {

                if (event.target.value.length > 60) {
                    this.setState({
                        errorMsg1: "",
                        snackbar: true,
                        successMsg: 'Username name must be between 4 and 60 characters',
                        snackColor: 'var(--danger-color)',
                    })

                }
                else {
                    let user_profile_info_edited_copy = this.state.user_profile_info_edited
                    if (event.target.value === 'none selected') {
                        user_profile_info_edited_copy[key] = ''
                    } else {
                        user_profile_info_edited_copy[key] = event.target.value
                    }
                    this.setState({ user_profile_info_edited: user_profile_info_edited_copy })
                }


            } else if (event.target.value.length < 4) {
                this.setState({
                    errorMsg1: "Username must be between 4 and 60 characters",
                })

                if (event.target.value.length > 60) {

                } else {
                    let user_profile_info_edited_copy = this.state.user_profile_info_edited
                    if (event.target.value === 'none selected') {
                        user_profile_info_edited_copy[key] = ''
                    } else {
                        user_profile_info_edited_copy[key] = event.target.value
                    }
                    this.setState({ user_profile_info_edited: user_profile_info_edited_copy })
                }
            }

            else {
                if (this.state.errorMsg1.length > 0) {
                    this.setState({
                        errorMsg1: "",
                    })
                }
                let user_profile_info_edited_copy = this.state.user_profile_info_edited
                if (event.target.value === 'none selected') {
                    user_profile_info_edited_copy[key] = ''
                } else {
                    user_profile_info_edited_copy[key] = event.target.value
                }
                this.setState({ user_profile_info_edited: user_profile_info_edited_copy })
            }
        } else {
            let user_profile_info_edited_copy = this.state.user_profile_info_edited
            if (event.target.value === 'none selected') {
                user_profile_info_edited_copy[key] = ''
            } else {
                user_profile_info_edited_copy[key] = event.target.value
            }
            this.setState({ user_profile_info_edited: user_profile_info_edited_copy })
        }
    }

    revertPersonalInfo(key) {
        let user_profile_info_edited_copy = this.state.user_profile_info_edited
        user_profile_info_edited_copy[key] = this.state.user_profile_info[key]
        this.setState({ user_profile_info_edited: user_profile_info_edited_copy })
    }

    get_profile_settings_page_django_data = get_and_post_data_skeleton

    render() {
        let demotest = true
        let email_verification_status_div = ""
        if (this.state.email_verified) {
            email_verification_status_div = <Typography style={{ color: 'var(--success-color)', marginBottom: '10px', textAlign: 'left', fontFamily: 'Roboto', display: 'flex', alignItems: 'center' }}>
                <MdOutlineMarkEmailRead style={{ fontSize: '24px' }} /> <span style={{ marginLeft: '7px', color: 'var(--success-color)', fontSize: '14px', fontWeight: '500' }}>Verified</span>
            </Typography>
        } else {
            if (this.state.email_sent) {
                email_verification_status_div =
                    <Typography style={{ color: 'var(--warning-color)', marginBottom: '10px', textAlign: 'left', fontFamily: 'Roboto', display: 'flex', alignItems: 'center' }}>
                        <MdOutlineMarkEmailUnread style={{ fontSize: '24px' }} /> <span style={{ marginLeft: '7px', color: 'var(--warning-color)', fontSize: '14px', fontWeight: '500' }}>Confirmation Email Sent</span>
                    </Typography>
            } else {
                email_verification_status_div =
                    <Typography style={{ color: 'var(--danger-color)', marginBottom: '20px', textAlign: 'left', fontFamily: 'Roboto', display: 'flex', alignItems: 'center' }}>
                        <MdOutlineMailLock style={{ fontSize: '24px', color: '#8A8A8A', }} /> <span style={{ marginLeft: '7px', color: '#8A8A8A', fontSize: '14px', fontWeight: '500' }}>Unverified</span>
                        <Button
                            disableRipple
                            fullWidth
                            variant="contained"
                            sx={{
                                width: 'auto',
                                backgroundColor: 'var(--brand-color)',
                                fontSize: '14px',
                                textTransform: 'none',
                                borderRadius: '8px',
                                marginLeft: '20px',
                                boxShadow: 'none',
                                fontWeight: '600',
                                fontFamily: 'Roboto',
                                ':hover': {
                                    backgroundColor: 'var(--brand-color-hover)',
                                    color: '#fff', boxShadow: 'none',
                                },
                            }}
                            onClick={(e) => this.SendNewVerificationEmail(e)}
                        >
                            Resend Email
                        </Button></Typography>
            }
        }

        let username_icon = ""
        if (this.state.user_profile_info['username'] === this.state.user_profile_info_edited['username']) {
            username_icon = <EditIcon
                sx={{
                    paddingRight: '0px',
                    color: '#9CA3BF',
                }}
            />
        } else {
            username_icon = <IconButton
                onClick={() => this.revertPersonalInfo('username')}
                sx={{
                    paddingRight: '0px',
                    color: '#9CA3BF',
                }}
            >
                <RestoreIcon />
            </IconButton>
        }
        let name_icon = ""
        if (this.state.user_profile_info['name'] === this.state.user_profile_info_edited['name']) {
            name_icon = <EditIcon
                sx={{
                    paddingRight: '0px',
                    color: '#9CA3BF',
                }}
            />
        } else {
            name_icon = <IconButton
                onClick={() => this.revertPersonalInfo('name')}
                sx={{
                    paddingRight: '0px',
                    color: '#9CA3BF',
                }}
            >
                <RestoreIcon />
            </IconButton>
        }
        let update_profile_button = ''
        if (
            (this.state.user_profile_info_edited['name'] === this.state.user_profile_info['name'])
            && (this.state.user_profile_info_edited['gender'] === this.state.user_profile_info['gender'])
            && (this.state.user_profile_info_edited['country'] === this.state.user_profile_info['country'])
            && (this.state.user_profile_info_edited['username'] === this.state.user_profile_info['username'])
        ) {
            update_profile_button = ''
        } else {
            update_profile_button = (
                <Button
                    disableRipple
                    disabled={this.state.errorMsg2 !== '' || this.state.errorMsg1 !== ''}
                    fullWidth
                    variant="contained"
                    sx={{
                        width: '100%',
                        backgroundColor: 'var(--brand-color)',
                        fontSize: '16px',
                        textTransform: 'none',
                        marginTop: '10px',
                        borderRadius: '8px',
                        float: 'left',
                        boxShadow: 'none',
                        fontWeight: '600',
                        fontFamily: 'Roboto',
                        ':hover': {
                            backgroundColor: 'var(--brand-color-hover)',
                            color: 'white', boxShadow: 'none',
                        },
                    }}
                    onClick={(e) => this.SubmitPersonalInfo(e)}
                >
                    Update Profile
                </Button>
            )
        }


        let personal_info_div = (
            <Grid xs={12} sm={12} md={12} lg={12}
                sx={{
                    margin: '0px auto 40px auto', paddingTop: '20px',
                    boxSizing: 'border-box',
                    border: '1px solid #E4EBF6',
                    fontFamily: 'Roboto',
                    borderRadius: '8px',
                    padding: '20px',
                    backgroundColor: '#fff',
                    marginTop: '20px',
                    height: 'auto',
                    width: '100%',
                }}>
                <Grid container sx={{ margin: '0 auto' }}>
                    <Grid xs={12} sx={{ textAlign: 'left' }}>
                        <p style={{ fontSize: '16px', margin: '0px 0px 10px 0px', fontWeight: '600', fontFamily: 'Roboto' }}>Personal Information</p>
                        <p style={{ marginTop: '8px', fontSize: '14px', color: '#6E89AF', marginBottom: '20px', fontWeight: '500', fontFamily: 'Roboto' }}>
                            Update your profile information and settings
                        </p>

                        <Grid container alignItems="center"
                            justifyContent="left" sx={{
                                width: '100%',
                                marginBottom: '40px',
                                fontSize: 'calc(14px + 0.1vw)',
                                fontFamily: 'Roboto'
                            }}>
                            <SettingsIconImageDiv
                                influencer_bool={this.props.influencer_bool}
                                url={this.props.current_user_icon}
                                onUpdate={(newUrl) => this.props.onUserIconUpdate(newUrl)}
                                size={'mini'}
                            />
                        </Grid>

                        <Grid container sx={{
                            width: '100%',
                            marginLeft: '0px',
                            marginRight: 'auto',
                            fontSize: 'calc(14px + 0.1vw)',
                            fontFamily: 'Roboto'
                        }}>
                            <Grid xs={12} sx={{ padding: '0px' }}>
                                <p className={'text-input-label'}>Age</p>
                                <input type="text" className={'text-input email-field'} id={"emailCaptureInput"}
                                    style={{
                                        border: '1px solid #D9DADB', display: 'block', fontWeight: '500',
                                        margin: '0px auto 25px 0px', fontSize: '16px',
                                        padding: '10px 15px', color: '#1D1D1D', borderRadius: '5px',
                                        width: '100%', fontFamily: 'Roboto',
                                        boxSizing: 'border-box'
                                    }} placeholder={'Over 16'} disabled
                                />

                                <p className={'text-input-label'}>Display Name</p>
                                <input type="text"
                                    className={'text-input email-field'} id={"emailCaptureInput"}
                                    style={{
                                        border: '1px solid #D9DADB', display: 'block', fontWeight: '500',
                                        margin: '0px auto 25px 0px', fontSize: '16px',
                                        padding: '10px 15px', color: '#222222', borderRadius: '5px',
                                        width: '100%', fontFamily: 'Roboto',
                                        boxSizing: 'border-box'
                                    }} placeholder={'Enter your display name...'}
                                    value={this.state.user_profile_info_edited['name']}
                                    onChange={(event) => this.UpdatePersonalInfo(event, 'name')}
                                />
                                <p className="error_message" style={{ textAlign: 'left', fontSize: '12px', color: 'var(--danger-color)', margin: '0px 0px 15px 0px', fontFamily: 'Roboto' }}>{this.state.errorMsg2}</p>

                                <p className={'text-input-label'}>Username</p>
                                <input type="text" className={'text-input email-field'} id={"emailCaptureInput"}
                                    style={{
                                        border: '1px solid #D9DADB', display: 'block', fontWeight: '500',
                                        margin: '0px auto 25px 0px', fontSize: '16px',
                                        padding: '10px 15px', color: '#222222', borderRadius: '5px',
                                        width: '100%', fontFamily: 'Roboto',
                                        boxSizing: 'border-box'
                                    }} placeholder={'Enter your username...'}
                                    value={this.state.user_profile_info_edited['username']}
                                    onChange={(event) => this.UpdatePersonalInfo(event, 'username')}
                                />
                                <p className="error_message" style={{ textAlign: 'left', fontSize: '12px', color: 'var(--danger-color)', margin: '0px 0px 15px 0px', fontFamily: 'Roboto' }}>{this.state.errorMsg1}</p>

                                <p className={'text-input-label'}>Email</p>
                                <input type="text" className={'text-input email-field'} id={"emailCaptureInput"}
                                    style={{
                                        border: '1px solid #D9DADB', display: 'block', fontWeight: '500',
                                        margin: '0px auto 25px 0px', fontSize: '16px',
                                        padding: '10px 15px', color: '#1D1D1D', borderRadius: '5px',
                                        width: '100%', fontFamily: 'Roboto',
                                        boxSizing: 'border-box'
                                    }} placeholder={this.state.user_profile_info['email']} disabled
                                />

                                <p className={'text-input-label'}>Join Date</p>
                                <input type="text" className={'text-input email-field'} id={"emailCaptureInput"}
                                    style={{
                                        border: '1px solid #D9DADB', display: 'block', fontWeight: '500',
                                        margin: '0px auto 25px 0px', fontSize: '16px',
                                        padding: '10px 15px', color: '#1D1D1D', borderRadius: '5px',
                                        width: '100%', fontFamily: 'Roboto',
                                        boxSizing: 'border-box'
                                    }} placeholder={this.state.user_profile_info['date_joined']} disabled
                                />

                                <p className={'text-input-label'}>Country</p>
                                <Select
                                    sx={{
                                        maxHeight: '48px', minHeight: '48px', backgroundColor: 'white', zIndex: '999',
                                        width: '100%', borderRadius: '5px',
                                        margin: '0px auto 25px 0px',
                                        border: '1px solid #D9DADB',
                                        fontFamily: 'Roboto',
                                        '&:hover': {
                                            outline: 'none'
                                        },
                                        '&.Mui-focused': {
                                            outline: 'none'
                                        }
                                    }}
                                    IconComponent={(props) => (
                                        <FaChevronDown style={{ fontSize: '14px', marginRight: '10px', color: '#757575' }} {...props} />
                                    )}
                                    value={this.state.user_profile_info_edited['country'] ?? " "}
                                    onChange={(event) => this.UpdatePersonalInfo(event, 'country')}
                                    MenuProps={{ style: { zIndex: '9999' } }}
                                >
                                    {['United Kingdom', 'United States', 'Australia', '---', ...this.state.country_list].map(
                                        (country, i) => {
                                            return (
                                                <MenuItem value={country} sx={{ textAlign: 'left', fontFamily: 'Roboto' }} disabled={i === 3 ? true : false}>
                                                    {country}
                                                </MenuItem>
                                            )
                                        }
                                    )}
                                </Select>

                                <p className={'text-input-label'}>Gender</p>
                                <Select
                                    sx={{
                                        maxHeight: '48px', minHeight: '48px', backgroundColor: 'white', zIndex: '999',
                                        width: '100%', borderRadius: '5px',
                                        margin: '0px auto 25px 0px',
                                        border: '1px solid #D9DADB',
                                        fontFamily: 'Roboto',
                                        '&:hover': {
                                            outline: 'none'
                                        },
                                        '&.Mui-focused': {
                                            outline: 'none'
                                        }
                                    }}
                                    IconComponent={(props) => (
                                        <FaChevronDown style={{ fontSize: '14px', marginRight: '10px', color: '#757575' }} {...props} />
                                    )}
                                    value={this.state.user_profile_info_edited['gender'] ?? " "}
                                    onChange={(event) => this.UpdatePersonalInfo(event, 'gender')}
                                    MenuProps={{ style: { zIndex: '9999' } }}
                                >
                                    <MenuItem value={"female"} sx={{ fontFamily: 'Roboto' }}>Female</MenuItem>
                                    <MenuItem value={"male"} sx={{ fontFamily: 'Roboto' }}>Male</MenuItem>
                                    <MenuItem value={"other"} sx={{ fontFamily: 'Roboto' }}>Other</MenuItem>
                                    <MenuItem value={"prefer to not say"} sx={{ fontFamily: 'Roboto' }}>Prefer to not say</MenuItem>
                                </Select>

                                {update_profile_button}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )

        let email_section = (
            <Grid xs={12} sm={12} md={12} lg={12}
                sx={{
                    margin: '20px auto 40px auto', paddingTop: '20px',
                    border: '1px solid #E4EBF6',
                    borderRadius: '8px',
                    padding: '20px',
                    backgroundColor: '#fff',
                    marginTop: '20px',
                    height: 'auto',
                    width: 'auto',
                    fontFamily: 'Roboto'
                }}>
                <Grid container sx={{ margin: '0 auto' }}>
                    <Grid xs={12} sx={{ textAlign: 'left' }}>
                        <p style={{ fontSize: '16px', margin: '0px 0px 10px 0px', fontWeight: '600', fontFamily: 'Roboto' }}>Email Settings</p>
                        <p style={{ marginTop: '8px', fontSize: '14px', color: '#6E89AF', marginBottom: '20px', fontWeight: '500', fontFamily: 'Roboto' }}>
                            Manage your email preferences and verification status
                        </p>
                        <p className={'text-input-label'}>Email Verification</p>
                        {email_verification_status_div}

                        <p className={'text-input-label'}>Opt-in Emails</p>
                        <Stack direction="row" spacing={1} alignItems="center" style={{ paddingBottom: '10px' }}>
                            <p className='small_profile_info_text'>No</p>
                            <AntSwitch
                                checked={this.state.email_opt_in}
                                onChange={(e) => this.handleEmailOptInChange(e)}
                            />
                            <p className='small_profile_info_text'>Yes</p>
                        </Stack>
                    </Grid>
                </Grid>
            </Grid>
        )

        let terms_section = (
            <Grid xs={12} sm={12} md={12} lg={12}
                sx={{
                    margin: '20px auto 40px auto', paddingTop: '20px',
                    border: '1px solid #E4EBF6',
                    borderRadius: '8px',
                    padding: '20px',
                    backgroundColor: '#fff',
                    marginTop: '20px',
                    height: 'auto',
                    width: 'auto',
                    fontFamily: 'Roboto'
                }}>
                <Grid container sx={{ margin: '0 auto' }}>
                    <Grid xs={12} sx={{ textAlign: 'left' }}>
                        <p style={{ fontSize: '16px', margin: '0px 0px 10px 0px', fontWeight: '600', fontFamily: 'Roboto' }}>Terms of Service</p>
                        <p style={{ marginTop: '8px', fontSize: '14px', color: '#6E89AF', marginBottom: '20px', fontWeight: '500', fontFamily: 'Roboto' }}>
                            View the WithMe Terms of Service
                        </p>
                        <Button
                            disableRipple
                            variant="contained"
                            sx={{
                                width: 'auto',
                                backgroundColor: 'var(--brand-color)',
                                fontSize: '14px',
                                textTransform: 'none',
                                marginTop: '0px',
                                borderRadius: '8px',
                                boxShadow: 'none',
                                fontWeight: '600',
                                fontFamily: 'Roboto',
                                ':hover': {
                                    backgroundColor: 'var(--brand-color-hover)',
                                    color: 'white',
                                    boxShadow: 'none',
                                },
                            }}
                            onClick={() => this.setState({
                                password_edit_visible: true
                            })}
                        >View Terms of Service</Button>
                    </Grid>
                </Grid>
            </Grid>
        )

        let privacy_section = (
            <Grid xs={12} sm={12} md={12} lg={12}
                sx={{
                    margin: '20px auto 40px auto', paddingTop: '20px',
                    border: '1px solid #E4EBF6',
                    borderRadius: '8px',
                    padding: '20px',
                    backgroundColor: '#fff',
                    marginTop: '20px',
                    height: 'auto',
                    width: 'auto',
                    fontFamily: 'Roboto'
                }}>
                <Grid container sx={{ margin: '0px auto 0px auto' }}>
                    <Grid xs={12} sx={{ textAlign: 'left' }}>
                        <p style={{ fontSize: '16px', margin: '0px 0px 10px 0px', fontWeight: '600', fontFamily: 'Roboto' }}>Privacy Policy</p>
                        <p style={{ marginTop: '8px', fontSize: '14px', color: '#6E89AF', marginBottom: '20px', fontWeight: '500', fontFamily: 'Roboto' }}>
                            View the WithMe Privacy Policy
                        </p>
                        <Button
                            disableRipple
                            variant="contained"
                            sx={{
                                width: 'auto',
                                backgroundColor: 'var(--brand-color)',
                                fontSize: '14px',
                                textTransform: 'none',
                                marginTop: '0px',
                                borderRadius: '8px',
                                boxShadow: 'none',
                                fontWeight: '600',
                                fontFamily: 'Roboto',
                                ':hover': {
                                    backgroundColor: 'var(--brand-color-hover)',
                                    color: 'white',
                                    boxShadow: 'none',
                                },
                            }}
                            onClick={() => this.setState({
                                password_edit_visible: true
                            })}
                        >View Privacy Policy</Button>
                    </Grid>
                </Grid>
            </Grid>
        )

        let help_improve_section = (
            <Grid xs={12} sm={12} md={12} lg={12}
                sx={{
                    margin: '20px auto 40px auto', paddingTop: '20px',
                    border: '1px solid #E4EBF6',
                    borderRadius: '8px',
                    padding: '20px',
                    backgroundColor: '#fff',
                    marginTop: '20px',
                    height: 'auto',
                    width: 'auto',
                    fontFamily: 'Roboto'
                }}>
                <Grid container sx={{ margin: '0px auto 0px auto' }}>
                    <Grid xs={12} sx={{ textAlign: 'left' }}>
                        <p style={{ fontSize: '16px', margin: '0px 0px 10px 0px', fontWeight: '600', fontFamily: 'Roboto' }}>Help Improve WithMe</p>
                        <p style={{ marginTop: '8px', fontSize: '14px', color: '#6E89AF', marginBottom: '20px', fontWeight: '500', fontFamily: 'Roboto' }}>
                            Share your feedback to help us improve WithMe
                        </p>
                        <Button
                            disableRipple
                            variant="contained"
                            sx={{
                                width: 'auto',
                                backgroundColor: 'var(--brand-color)',
                                fontSize: '14px',
                                textTransform: 'none',
                                marginTop: '0px',
                                borderRadius: '8px',
                                boxShadow: 'none',
                                fontWeight: '600',
                                fontFamily: 'Roboto',
                                ':hover': {
                                    backgroundColor: 'var(--brand-color-hover)',
                                    color: 'white',
                                    boxShadow: 'none',
                                },
                            }}
                            onClick={() => { window.open('https://pmfsurvey.com/g/8127', "_blank") }}
                        >
                            Share Feedback
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        )

        let password_section = (
            <Grid xs={12} sm={12} md={12} lg={12}
                sx={{
                    margin: '20px auto 40px auto', paddingTop: '20px',
                    border: '1px solid #E4EBF6',
                    borderRadius: '8px',
                    padding: '20px',
                    backgroundColor: '#fff',
                    marginTop: '20px',
                    height: 'auto',
                    width: 'auto',
                    fontFamily: 'Roboto'
                }}>
                <Grid container sx={{ margin: '0 auto' }}>
                    <Grid xs={12} sx={{ textAlign: 'left' }}>
                        <p style={{ fontSize: '16px', margin: '0px 0px 10px 0px', fontWeight: '600', fontFamily: 'Roboto' }}>Update your Password</p>
                        <p style={{ marginTop: '8px', fontSize: '14px', color: '#6E89AF', marginBottom: '20px', fontWeight: '500', fontFamily: 'Roboto' }}>
                            Change your account password to keep your account secure
                        </p>
                        <Button
                            disableRipple
                            variant="contained"
                            sx={{
                                width: 'auto',
                                backgroundColor: 'var(--brand-color)',
                                fontSize: '14px',
                                textTransform: 'none',
                                marginTop: '0px',
                                borderRadius: '8px',
                                boxShadow: 'none',
                                fontWeight: '600',
                                fontFamily: 'Roboto',
                                ':hover': {
                                    backgroundColor: 'var(--brand-color-hover)',
                                    color: 'white',
                                    boxShadow: 'none',
                                },
                            }}
                            onClick={() => this.setState({
                                password_edit_visible: true
                            })}
                        >Update Password</Button>
                    </Grid>
                </Grid>
            </Grid>
        )

        // let delete_account_section = (
        //     <Grid xs={12} sm={12} md={12} lg={12}
        //         sx={{
        //             margin: '20px auto 20px auto', paddingTop: '20px',
        //             border: '1px solid #E4EBF6',
        //             borderRadius: '8px',
        //             padding: '20px',
        //             backgroundColor: '#fff',
        //             marginTop: '20px',
        //             height: 'auto',
        //             width: 'auto',
        //             fontFamily: 'Roboto'
        //         }}>
        //         <Grid container sx={{ margin: '0 auto' }}>
        //             <Grid xs={12} sx={{ textAlign: 'left' }}>
        //                 <p style={{ fontSize: '16px', margin: '0px 0px 10px 0px', fontWeight: '600', fontFamily: 'Roboto' }}>Delete Account</p>
        //                 <p style={{ marginTop: '8px', fontSize: '14px', color: '#6E89AF', marginBottom: '20px', fontWeight: '500', fontFamily: 'Roboto' }}>
        //                     Permanently delete your account and all associated data
        //                 </p>
        //                 <Button
        //                     disableRipple
        //                     variant="contained"
        //                     sx={{
        //                         width: 'auto',
        //                         backgroundColor: 'var(--danger-color)',
        //                         fontSize: '14px',
        //                         borderRadius: '8px',
        //                         textTransform: 'none',
        //                         marginTop: '0px',
        //                         boxShadow: 'none',
        //                         fontWeight: '600',
        //                         fontFamily: 'Roboto',
        //                         ':hover': {
        //                             backgroundColor: 'var(--danger-color-hover)',
        //                             color: 'white',
        //                             boxShadow: 'none',
        //                         },
        //                     }}
        //                     onClick={() => this.setState({
        //                         delete_account_visible: true
        //                     })}
        //                 >Delete Account</Button>
        //             </Grid>
        //         </Grid>
        //     </Grid>
        // )

        return (
            <>
                {this.state.loading ?
                    <>
                        <Typography style={{ color: '#222222', fontSize: '26px', fontWeight: '600', fontFamily: 'Roboto' }}>Settings</Typography>
                        <PageSkeletonProfile />
                    </>
                    :
                    <div style={{ maxWidth: '100vw', padding: '0px' }}>
                        <Grid container sx={{ width: '100%', padding: '0px', margin: '0px' }}
                            alignItems="left"
                            justifyContent="left">
                            <Typography style={{ color: '#222222', fontSize: '26px', fontWeight: '600', fontFamily: 'Roboto' }}>Settings</Typography>



                            {/* Tabs */}

                            <div style={{ margin: '20px 0px 0px 0px', display: 'block', width: '100%' }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    gap: { xs: "10px", lg: "10px" },
                                    padding: { xs: "5px", lg: "5px" },
                                    backgroundColor: "#fff",
                                    borderRadius: "10px",
                                    alignItems: "center",
                                    border: "1px solid #eaeef3",
                                    width: { xs: 'max-content', lg: 'max-content' },
                                    maxWidth: "100%",
                                    overflowX: "hidden",
                                    height: { xs: "auto", lg: "auto" },
                                    justifyContent: { xs: "space-between", lg: "flex-start" },
                                    marginBottom: '20px'
                                }}
                            >
                                {this.getTabs().map((tab) => (
                                    <Box key={tab.label} sx={{ display: "flex", alignItems: "center", flexShrink: 1 }}>
                                        <Button
                                            onClick={() => !tab.comingSoon && this.handleTabChange(tab.label)}
                                            sx={{
                                                borderRadius: "8px",
                                                fontSize: { xs: "14px", lg: "14px" },
                                                fontWeight: 600,
                                                cursor: tab.comingSoon ? "default" : "pointer",
                                                textTransform: "none",
                                                color: this.state.activeTab === tab.label ? "#fff" : "#222",
                                                backgroundColor: this.state.activeTab === tab.label ? "var(--brand-color)" : "transparent",
                                                "&:hover": {
                                                    backgroundColor: this.state.activeTab === tab.label ? "var(--brand-color-hover)" : "transparent",
                                                },
                                                whiteSpace: "nowrap",
                                                textOverflow: "ellipsis",
                                                flex: "1 1 auto",
                                                minWidth: { xs: "60px", lg: "auto" },
                                                gap: 0.5,
                                                display: "flex",
                                                padding: { xs: '8px 15px', lg: '8px 20px' },
                                                alignItems: "center",
                                                justifyContent: "center",
                                                position: "relative",
                                            }}
                                        >
                                            {tab.label}
                                        </Button>
                                    </Box>
                                ))}
                            </Box>
                            </div>

                            {/* Content based on active tab */}
                            {this.state.activeTab === 'Profile' && (
                                <>
                                    <Grid item xs={12} sm={12} md={12} lg={12} sx={{ textAlign: 'left', marginTop: '0px' }}>
                                        <EditDetailsPopup
                                            show_modal={this.state.personal_edit_on}
                                            user_profile_info={this.state.user_profile_info}
                                            country_list={this.state.country_list}
                                            closeButton={() => {
                                                this.setState({
                                                    personal_edit_on: false
                                                })
                                            }}
                                            UpdatePersonalInfo={this.UpdatePersonalInfo}
                                            SubmitPersonalInfo={this.SubmitPersonalInfo}
                                            UpdatePersonalInfoPostUpdate={this.UpdatePersonalInfoPostUpdate}
                                        />

                                        <PasswordUpdatePopup
                                            updating_password={this.state.password_edit_visible}
                                            close_updating_password={() => {
                                                this.setState({
                                                    password_edit_visible: false
                                                })
                                            }}
                                            show_password_complete_snackbar={() => {
                                                this.setState({
                                                    snackbar: true,
                                                    successMsg: 'Password Successfully Changed',
                                                    snackColor: 'var(--brand-color)',
                                                })
                                            }}
                                        />
                                        <DeleteAccountPopup
                                            open_modal={this.state.delete_account_visible}
                                            close_delete_account={() => {
                                                this.setState({
                                                    delete_account_visible: false
                                                })
                                            }}
                                        />
                                        {personal_info_div}
                                        {email_section}
                                        {password_section}
                                        {/* {terms_section}
                        {privacy_section}
                        {help_improve_section} */}
                                        {/* {delete_account_section} */}
                                        <div style={{
                                            marginTop: '20px'
                                        }}>
                                        </div>
                                    </Grid>
                                </>
                            )}
                            {this.state.activeTab === 'Billing' && (
                                 <Grid
                                 Container
                                 xs={12}
                              >
                                 <Grid container>
                                    <Grid xs={12} sx={{ backgroundColor: '#fff', padding: '20px', borderRadius: '8px', border: '1px solid #E4EBF6', marginTop: '20px' }}>
                                        <p style={{ fontSize: '16px', margin: '0px 0px 10px 0px', fontWeight: '600', fontFamily: 'Roboto' }}>Billing</p>
                                        <p style={{ marginTop: '8px', fontSize: '14px', color: '#6E89AF', marginBottom: '0px', fontWeight: '500', fontFamily: 'Roboto' }}>
                                            Manage your WithMe subscription, including modifying or canceling your plan.
                                        </p>
                                       
                                       {/* <span style={smallHeading}>
                                          Manage Billing
                                       </span>
                                       <span style={smallDescription}>
                                          Manage your WithMe subscription, including modifying or canceling your plan.
                                       </span> */}
                  
                                       <Button
                                          disableRipple
                                          variant="contained"
                                          sx={{
                                             backgroundColor: 'var(--brand-color)',
                                             fontSize: '14px',
                                             textTransform: 'none',
                                             boxShadow: 'none',
                                             marginTop: '20px',
                                             borderRadius: '8px',
                                             fontWeight: '600',
                                             ':hover': {
                                                backgroundColor: 'var(--brand-color-hover)',
                                                color: 'white',
                                                boxShadow: 'none',
                                             },
                                          }}
                                          onClick={() => {
                                             setTimeout(() => {
                                                window.open(this.state.link_url)
                                             }, 800);
                                          }}>
                                          Go to Billing Portal
                                       </Button>
                                    </Grid>
                                 </Grid>
                              </Grid>
                            )}




































                            <SnackbarAlert
                                msg={this.state.successMsg}
                                backgroundColor={this.state.snackColor}
                                open={this.state.snackbar}
                                severity={'success'}
                                handleClose={() => {
                                    this.setState({
                                        snackbar: false
                                    })
                                }}
                            />
                        </Grid>

                    </div>
                }
            </>

        )
    }
}

export default CreatorProfile;
